export default __webpack_public_path__ + "static/media/word.89f1b321.svg";